// @mui
import { Container, Grid } from '@mui/material';

import { observer } from 'mobx-react-lite';
import { useStore } from 'src/stores/store';

//Localization
import useLocales from 'src/hooks/useLocales';
import Page from 'src/components/Page';
import useSettings from 'src/hooks/useSettings';
import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs';
import { PATH_DASHBOARD } from 'src/routes/paths';
import FinancialPaymentDetailTableRow from './FinancialPaymentDetailTableRow';
import { useEffect, useState } from 'react';
import Loader from 'src/components/loader/Loader';
// ----------------------------------------------------------------------

export default observer(function FinancialPaymentDetailHeader() {
  const { translate } = useLocales();
  const [isLoading, setIsLoading] = useState(true); // Track loading state
  const {
    FinancialPaymentStore: { selectedFinancialPaymentDetail, clearSelectedFinancialPayment, ID, loadFinancialPaymentDetail },
  } = useStore();

  useEffect(() => {
    if (ID) {
      setIsLoading(true);
      loadFinancialPaymentDetail(ID).finally(() => setIsLoading(false)); // Ensure loading ends
    }
  }, [loadFinancialPaymentDetail, ID]);

  const { themeStretch } = useSettings();
  return (
    <Page title={translate('FinancialPayment.FinancialPaymentDetails')}>
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <HeaderBreadcrumbs
          heading={translate('FinancialPayment.FinancialPaymentDetails')}
          links={[
            { name: `${translate('Department.Dashboard')}`, href: PATH_DASHBOARD.root },
            { name: `${translate('FinancialPayment.FinancialPaymentList')}`, href: PATH_DASHBOARD.FinancialPayment.list },
            { name: `${translate('FinancialPayment.FinancialPaymentDetails')}` },
          ]}
        />

        {isLoading ? ( // Show loading state
          <Grid container justifyContent="center" alignItems="center" style={{ height: '50vh' }}>

            <Loader /> {/* Replace with Loader */}
          </Grid>
        ) : selectedFinancialPaymentDetail ? ( // Render details if available
          <Grid container>
            <Grid container>
              <FinancialPaymentDetailTableRow row={selectedFinancialPaymentDetail!} />
            </Grid>
          </Grid>
        ) : (
          <Grid container justifyContent="center" alignItems="center" style={{ height: '50vh' }}>
            <p>{translate('ElectricBox.NoData')}</p>
          </Grid>
        )}

      </Container>
    </Page>
  );
});
